import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuthStore from '../store/authStore';
import { authService } from '../services/api';

export default function VerificationBanner() {
  const { user } = useAuthStore();
  const { t } = useTranslation();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.is_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await authService.resendVerification();
      setSent(true);
    } catch (e) {
      // Non-critical UI feedback path; silently ignore transient failures.
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm text-amber-800">
      <span>
        {sent
          ? t('Verification email sent — check your inbox.')
          : t('Please verify your email address to unlock all features.')}
      </span>
      {!sent && (
        <button
          onClick={handleResend}
          disabled={sending}
          className="font-medium underline hover:no-underline disabled:opacity-50"
        >
          {sending ? t('Sending...') : t('Resend verification email')}
        </button>
      )}
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-500 hover:text-amber-700 ms-1"
        aria-label={t('Dismiss')}
      >
        ✕
      </button>
    </div>
  );
}
